import useSiteContent from '../Content/useSiteContent';
import ContentNotice from '../Content/ContentNotice';

const FAQ = () => {
  const { data, unavailable } = useSiteContent('faq');
  return <div className="main_page_container">
    <ContentNotice unavailable={unavailable} />
    <h1 className="page_title">Frequently Asked Questions</h1>
    <div className="faq-style-wrapper">
      <h2>{data.title}</h2>
      {data.items.map((item, index) => <details className="faq-entry" key={index}>
        <summary>{item.question}</summary>
        <p className="editable-text">{item.answer}</p>
      </details>)}
    </div>
  </div>;
};
export default FAQ;
